import { createSlice, createAsyncThunk, createEntityAdapter } from "@reduxjs/toolkit";
import salonmoduleApiController from "../../services/salonmodule.service";
import HandleError from "../HandleError";
import HandleResponse from "../HandleResponse";
export const usersAdapter = createEntityAdapter();

export const salonmoduleListViewApi = createAsyncThunk("salonmodule/modulelistview", async (formValues, thunkAPI) => {
  try {
    const resposedata = await salonmoduleApiController
      .moduleview(formValues, thunkAPI)
      .then((response) => HandleResponse(thunkAPI, response, "modulelistview"))
      .catch((error) => HandleError(thunkAPI, error, "modulelistview"));
    return resposedata;
  } catch (error) {
    const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
    return thunkAPI.rejectWithValue(message);
  }
});

export const salonmoduleAccessViewApi = createAsyncThunk("salonmodule/accesslistview", async (formValues, thunkAPI) => {
  try {
    const resposedata = await salonmoduleApiController
      .accessview(formValues, thunkAPI)
      .then((response) => HandleResponse(thunkAPI, response, "accesslistview"))
      .catch((error) => HandleError(thunkAPI, error, "accesslistview"));
    return resposedata;
  } catch (error) {
    const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
    return thunkAPI.rejectWithValue(message);
  }
});

export const salonModuleAccessUpdateApi = createAsyncThunk("salonmodule/update", async (formvalues, thunkAPI) => {
  try {
    const resposedata = await salonmoduleApiController
      .update(formvalues, thunkAPI)
      .then((response) => HandleResponse(thunkAPI, response, "update"))
      .catch((error) => HandleError(thunkAPI, error, "update"));
    return resposedata;
  } catch (error) {
    const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
    return thunkAPI.rejectWithValue({ status: error.response.status, message: message });
  }
});

const initialState = {
  isListView: [],
  isAccessView: [],
  isAccess: [],
  isApiStatus: { SalonModule: "", SalonAccess: "" },
};

const salonmoduleSlice = createSlice({
  name: "salonmodule",
  initialState,
  reducers: {
    reset: () => initialState,
    salonModuleAccessAction: (state, action) => {
      const { id, ...changes } = action.payload;
      const existingData = state.isAccessView.find((event) => event.id === id);
      if (existingData) {
        Object.keys(changes).map((keyName) => {
          existingData[keyName] = changes[keyName];
        });
      }
      // state.isAddonServices = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
    .addCase(salonmoduleListViewApi.pending, (state) => {
      state.isApiStatus = { ...state.isApiStatus, SalonModule: "loading" };
    })
    .addCase(salonmoduleListViewApi.fulfilled, (state, action) => {
      state.isApiStatus = { ...state.isApiStatus, SalonModule: "succeeded" };
      state.isListView = action.payload;
    })
    .addCase(salonmoduleListViewApi.rejected, (state) => {
      state.isApiStatus = { ...state.isApiStatus, SalonModule: "failed" };
      state.isListView = [];
    })
    .addCase(salonmoduleAccessViewApi.pending, (state) => {
      state.isApiStatus = { ...state.isApiStatus, salonmoduleAccessViewApi: "loading" };
    })
    .addCase(salonmoduleAccessViewApi.fulfilled, (state, action) => {
      state.isAccessView = action.payload;
      const accessdata = state.isAccessView;
      let permissionModule = [];
      accessdata.map((list) => {
        let permission = [];
        list.salonpermission
          .filter((perm) => perm.access === true)
          .map((perm) => {
            permission.push(perm.name);
          });
        permissionModule.push({ permission: permission, module_id: list.id, controller: list.controller });
      });
      state.isApiStatus = { ...state.isApiStatus, salonmoduleAccessViewApi: "succeeded" };
      state.isAccess = permissionModule;
    })
    .addCase(salonmoduleAccessViewApi.rejected, (state) => {
      state.isApiStatus = { ...state.isApiStatus, salonmoduleAccessViewApi: "failed" };
      state.isAccessView = [];
    })
    .addCase(salonModuleAccessUpdateApi.pending, (state) => {
      state.isApiStatus = { ...state.isApiStatus, SalonAccessUpdate: "loading" };
    })
    .addCase(salonModuleAccessUpdateApi.fulfilled, (state) => {
      state.isApiStatus = { ...state.isApiStatus, SalonAccessUpdate: "succeeded" };
    })
    .addCase(salonModuleAccessUpdateApi.rejected, (state) => {
      state.isApiStatus = { ...state.isApiStatus, SalonAccessUpdate: "failed" };
    });
  },
});
// Action creators are generated for each case reducer function
export const { reset, salonModuleAccessAction } = salonmoduleSlice.actions;
export default salonmoduleSlice.reducer;
